import AirDatepicker from 'air-datepicker';
import localeEn from 'air-datepicker/locale/en';
import {smoothScrollPause, smoothScrollPlay} from "../scroll-smoother";


$(document).ready(function () {
  // Open file input when upload button is clicked
  $('.js--styled-file-upload .upload-file-button').click(function () {
    var $fileInput = $(this).siblings('input[type="file"]');
    $fileInput.click();
  });

  // Handle file input change
  $('.js--styled-file-upload input[type="file"]').change(function () {
    if ($(this).attr('multiple') !== undefined) {
      $('.multiple-files .js--clear-input').remove();
      var files = $(this)[0].files;
      $.each(files, function (index, file) {
        var fileName = file.name;
        var fileType = fileName.substring(fileName.lastIndexOf('.'));
        var fileNameWithoutExtension = fileName.substring(0, fileName.lastIndexOf('.'));

        // Limit name length to 40 characters
        if (fileNameWithoutExtension.length > 40) {
          fileNameWithoutExtension = fileNameWithoutExtension.substring(0, 40) + '...';
        }

        var $multipleFiles = $('.multiple-files');
        var infoToInsert = `<div class="file-info js--clear-input active">
                                    <div class="name">${fileNameWithoutExtension}</div>
                                    <div class="type">${fileType}</div>
                                    <div class="clear-btn">
                                        <svg width="16" height="16" viewBox="0 0 16 16" fill="none"
                                             xmlns="http://www.w3.org/2000/svg">
                                            <path d="M12 4L4 12" stroke="#191C2B" stroke-width="2"
                                                  stroke-linecap="square"/>
                                            <path d="M4 4L12 12" stroke="#191C2B" stroke-width="2"
                                                  stroke-linecap="square"/>
                                        </svg>
                                    </div>
                                </div>`

        $multipleFiles.append(infoToInsert);
      });

      if ($(this).hasClass('js--calc-first-step-images')) {
        const fileInputTwo = document.querySelector('.js--calc-second-step-images');
        fileInputTwo.files = files;
      }

      $('.js--styled-file-upload').on('click', '.js--clear-input', function () {
        var $fileInput = $(this).closest('.js--styled-file-upload').find('input[type="file"]');
        var $fileInfo = $(this).closest('.file-info');
        var files = Array.from($fileInput[0].files);
        var indexToRemove = $fileInfo.index();

        files.splice(indexToRemove, 1); // Remove file from files array
        const dataTransfer = new DataTransfer();
        files.forEach(file => dataTransfer.items.add(file));
        const fileInput = document.querySelector('input[type="file"]');
        fileInput.files = dataTransfer.files;

        if (fileInput.classList.contains('js--calc-first-step-images')) {
          const fileInputTwo = document.querySelector('.js--calc-second-step-images');
          fileInputTwo.files = dataTransfer.files;
        }

        $fileInfo.remove(); // Remove the file info container
      });
    } else {
      var file = $(this)[0].files[0];
      var fileName = file.name;
      var fileType = fileName.substring(fileName.lastIndexOf('.'));
      var fileNameWithoutExtension = fileName.substring(0, fileName.lastIndexOf('.'));

      // Limit name length to 40 characters
      if (fileNameWithoutExtension.length > 40) {
        fileNameWithoutExtension = fileNameWithoutExtension.substring(0, 40) + '...';
      }
      if($(this).hasClass('js--calc-first-step-images')) {
        const fileInputTwo = document.querySelector('.js--calc-second-step-images');
        fileInputTwo.files = file;
      }

      var $fileInfo = $(this).closest('.js--styled-file-upload').find('.file-info');
      $fileInfo.find('.name').text(fileNameWithoutExtension);
      $fileInfo.find('.type').text(fileType);
      $fileInfo.addClass('active');
    }
  });

  // Clear file input when clear button is clicked
  $('.js--styled-file-upload .js--clear-input').click(function () {
    var $fileInput = $(this).closest('.js--styled-file-upload').find('input[type="file"]');
    var $fileInfo = $(this).closest('.file-info');
    $fileInput.val('');
    $fileInfo.removeClass('active');
  });


  $('.styled-form-element input').on('change', function () {
    var inputName = $(this).attr('name');
    $('[data-validate-for="' + inputName + '"]').removeClass('oc-visible').text('');
  });

  $('.styled-checkbox input[type=checkbox]').change(
    function () {
      var inputName = $(this).attr('name');
      $('[data-validate-for="' + inputName + '"]').removeClass('oc-visible').text('');
    });

  const changeDateSelectorHeaderInfo = (inputDate) => {
    var parts = inputDate.split('/');
    var day = parts[0];
    var month = parts[1];
    var year = parts[2];

    var monthNames = ["Jan", "Feb", "Mar", "Apr", "May", "Jun",
      "Jul", "Aug", "Sep", "Oct", "Nov", "Dec"];
    var monthName = monthNames[parseInt(month) - 1];

    var formattedDate = new Date(parts[2], parts[1] - 1, parts[0]);
    var dayOfWeek = formattedDate.toLocaleDateString('en-US', {weekday: 'short'});
    var formattedDateString = dayOfWeek + ", " + monthName + " " + day;

    var yearVariable = year;
    var dateVariable = formattedDateString;

    $('.air-datepicker-header .small-title').text(yearVariable)
    $('.air-datepicker-header .title').text(dateVariable)
  }

  const dateFromString = (string) => {
    var parts = string.split('/');
    var day = parseInt(parts[0], 10);
    var month = parseInt(parts[1], 10) - 1; // Months are zero-based
    var year = parseInt(parts[2], 10);
    return new Date(year, month, day);
  }

  new AirDatepicker('#modal-date-selector', {
    inline: true,
    locale: {
      days: ['Sunday', 'Monday', 'Tuesday', 'Wednesday', 'Thursday', 'Friday', 'Saturday'],
      daysShort: ['Sun', 'Mon', 'Tue', 'Wed', 'Thu', 'Fri', 'Sat'],
      daysMin: ['S', 'M', 'T', 'W', 'T', 'F', 'S'],
      months: ['January', 'February', 'March', 'April', 'May', 'June', 'July', 'August', 'September', 'October', 'November', 'December'],
      monthsShort: ['Jan', 'Feb', 'Mar', 'Apr', 'May', 'Jun', 'Jul', 'Aug', 'Sep', 'Oct', 'Nov', 'Dec'],
      today: 'Today',
      clear: 'Clear',
      dateFormat: 'mm/dd/yyyy',
      timeFormat: 'hh:ii aa',
      firstDay: 1,
    },
    navTitles: {
      days: '<strong>MMMM yyyy</strong>',
    },
    minDate: new Date(),
    selectedDates: $('.js--init-date-modal').val() ? dateFromString($('.js--init-date-modal').val()) : '',
    onSelect: function (date) {
      const year = date.date.getFullYear();
      const month = String(date.date.getMonth() + 1).padStart(2, '0'); // Month is zero-based, so add 1 and pad with 0 if necessary
      const day = String(date.date.getDate()).padStart(2, '0'); // Pad day with 0 if necessary
      const formattedDate = `${day}/${month}/${year}`;
      $('#modal-date-selector, #date').val(formattedDate);
      changeDateSelectorHeaderInfo(formattedDate)
    }
  })

  $('.js--init-date-modal').click(function () {
    if ($(window).width() > 991) {
      $('#date-modal').addClass('modal-active')
      $('body').addClass('overflow-hidden');
      $('html').addClass('overflow-hidden');
      smoothScrollPause();
    }
  });

  function formatDate(inputDate) {
    var parts = inputDate.split('-');
    return parts[2] + '/' + parts[1] + '/' + parts[0];
  }

  if (!$('.js--init-date-modal').val()) {
    var currentDate = new Date();
    var day = currentDate.getDate();
    var month = currentDate.getMonth() + 1; // Month is zero-based, so we add 1
    var year = currentDate.getFullYear();

    if (day < 10) {
      day = '0' + day;
    }
    if (month < 10) {
      month = '0' + month;
    }

    var formattedDate = day + '/' + month + '/' + year;
    $('.js--init-date-modal').val(formattedDate);
    changeDateSelectorHeaderInfo(formattedDate)
  } else {
    changeDateSelectorHeaderInfo($('.js--init-date-modal').val())
  }

  $('.js--date-selector-input-hidden').on('change', function () {
    var newValue = $(this).val();
    var formattedDate = formatDate(newValue);
    $('.js--init-date-modal').val(formattedDate);
    changeDateSelectorHeaderInfo(formattedDate)
  });

  $('#date-modal .inner-children').on('click', function (event) {
    event.stopPropagation();
  });
  $('#date-modal .inner-parent').on('click', function () {
    const modal = $('#date-modal')
    modal.removeClass('modal-active');
    $('body').removeClass('overflow-hidden');
    $('html').removeClass('overflow-hidden');
    smoothScrollPlay();
  });

});
